import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { RequestLogResponse } from '../../responses/integration-it4d/request-log.response';

@Injectable({
  providedIn: 'root'
})
export class RequestLogService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public search(request: { datetimeInitRequest?: Date; searchText?: string; idHealthUnit: number; pageIndex: number; idRequestType?: number; }): Observable<RequestLogResponse> {
    let uri = `RequestLog/GetAll`

    return this.httpClient.post<RequestLogResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegrationIT4D) + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}